module.exports = "https://jsak.mmtcdn.com/tripmoney/static/media/Fbb SBI STYLEUP Contactless Card.2e134c12.png";